<ng-container *transloco="let t;">
    <div class="d-flex align-items-center justify-content-between">
        <span>
            {{ dataItem?.updated_at | dateFormat | async }}
        </span>
    </div>
</ng-container>